import React from "react";
import { Avatar, Tooltip } from "@mui/material";
import { MemberIcon } from "../../../constants/MemberIcon";
import { withTranslation } from "react-i18next";
import { getUrl } from "../../../helpers/file_helper";

const UserProfile = (props) => {
  return (
    <React.Fragment>
      {!props?.user?.profilePicture && props.tooltip &&
        <Tooltip title={props?.user?.name ?? "Unassign"}>
          <Avatar 
            className={props?.avatarClassName} {...MemberIcon(props?.user?.name ? props?.user?.name : props?.user?.label)} 
            style={props?.profileStyle}
          />
        </Tooltip>
      }
      {props?.user?.profilePicture && props.tooltip &&
        <Tooltip title={props?.user?.name ?? "Unassign"}>
          <img
            src={getUrl(props?.user?.profilePicture)}
            alt=''
            className={`rounded-circle header-profile-user ${props?.profileClassName}`}
            style={props?.profileStyle}
          />
        </Tooltip>

      }

      {!props?.user?.profilePicture && !props.tooltip &&
        <Avatar 
          className={props?.avatarClassName} {...MemberIcon(props?.user?.name ? props?.user?.name : props?.user?.label)} 
          style={props?.profileStyle}
        />
      }
      {props?.user?.profilePicture && !props.tooltip &&
        <img
          src={getUrl(props?.user?.profilePicture)}
          alt=''
          className={`rounded-circle header-profile-user ${props?.profileClassName}`}
          style={props?.profileStyle}
        />
      }
    </React.Fragment>
  );
};

export default withTranslation()(UserProfile);
